import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import bg from 'assets/img/analyzers-bg.png';
import paba from 'assets/img/analyzers-pa-ba.png';
import pacp from 'assets/img/analyzers-pa-cp.png';

import paba_ from 'assets/img/analyzers-circle-ba.png';
import pacp_ from 'assets/img/analyzers-circle-cp.png';

import { AnalyzerCard } from './Analyzers';

const Background = styled.div`
  text-align: center;
  color: #fff;
  width: 100%;
  height: 100%;
  background-image: url(${bg});
  background-repeat: no-repeat;
  background-position: 50% 0;
  background-size: cover;
  border-radius: 0.25rem;
  position: relative;
`;

function Analyzers({ session }) {
  const navigate = useNavigate();
  const { permissions } = session ?? {};

  return (
    <div class="tw-flex tw-flex-col tw-justify-center tw-p-8 tw-space-y-10 lg:tw-ml-14">
      <div>
        <button
          className="tw-mt-2 tw-ml-2 hover:tw-no-underline tw-font-semibold tw-px-[16px] tw-py-[9px] tw-border tw-border-solid tw-bg-[#323333] tw-text-white"
          onClick={() => navigate({ pathname: '/analyzers' }, { replace: false })}
        >
          Back
        </button>
      </div>

      {permissions.pa && (
        <AnalyzerCard
          title="Build & Analyze"
          description="Design, build, analyze and evaluate existing portfolios and proposed models."
          imgSrc={paba_}
          onClick={() => navigate({ pathname: '/pa/build', search: 'single=true' }, { replace: false })}
        />
      )}

      {permissions.pa && (
        <AnalyzerCard
          title="Compare Portfolios"
          description="Comprehensive quantitative risk analysis and side-by-side comparison of up to three portfolios at one time."
          imgSrc={pacp_}
          onClick={() => navigate({ pathname: '/pa/compare' }, { replace: false })}
        />
      )}
    </div>
    // <div className="tw-max-w-7xl tw-mx-auto tw-mt-10">
    //   <Background>
    //     <div className="tw-text-left">
    //       <button
    //         className="tw-mt-2 tw-ml-2 hover:tw-no-underline tw-font-semibold tw-px-[16px] tw-py-[9px] tw-border tw-border-solid tw-border-[#191970] tw-text-[#191970] tw-bg-white hover:tw-text-[#191970] focus:tw-text-[#191970]"
    //         onClick={() => navigate({ pathname: '/analyzers' }, { replace: false })}
    //       >
    //         Back
    //       </button>
    //     </div>
    //     <div className="tw-container tw-mx-auto tw-flex tw-flex-col tw-flex-wrap tw-px-3 tw-pb-12 md:tw-flex-row tw-cursor-pointer">
    //       {permissions.pa && (
    //         <div
    //           className="tw-mb-5 tw-w-full tw-px-3 lg:tw-w-1/2 hover:tw-underline"
    //           onClick={() => navigate({ pathname: '/pa/build', search: 'single=true' }, { replace: false })}
    //         >
    //           <h3 className="tw-w-full tw-text-center tw-text-3xl tw-font-bold tw-leading-tight">
    //             Build &
    //             <br />
    //             Analyze
    //           </h3>
    //           <img
    //             className="tw-mx-auto tw-w-full tw-max-w-[220px] tw-max-h-[195px] tw-mb-2"
    //             src={paba}
    //             alt="Discovery"
    //           />
    //           <p className="tw-mt-3 tw-text-2xl tw-mx-auto tw-max-w-[300px]"></p>
    //         </div>
    //       )}

    //       {permissions.pa && (
    //         <div
    //           className="tw-mb-5 tw-w-full tw-px-3 lg:tw-w-1/2 hover:tw-underline"
    //           onClick={() => navigate({ pathname: '/pa/compare' }, { replace: false })}
    //         >
    //           <h3 className="tw-w-full tw-text-center tw-text-3xl tw-font-bold tw-leading-tight">
    //             Compare
    //             <br />
    //             Portfolios
    //           </h3>
    //           <img
    //             className="tw-mx-auto tw-w-full tw-max-w-[220px] tw-max-h-[195px] tw-mb-2"
    //             src={pacp}
    //             alt="Discovery"
    //           />
    //           <p className="tw-mt-3 tw-text-2xl tw-mx-auto tw-max-w-[300px]"></p>
    //         </div>
    //       )}
    //     </div>
    //   </Background>
    // </div>
  );
}

export default Analyzers;
